import React from "react";
import { Sticky } from "react-sticky";

export function withSticky(WrappedComponent) {
  return props => {
    const {
      isSticky,
      topOffset,
      stickyStyle,
      stickyTopClassName,
      onStickyStateChange,
      ...otherProps
    } = props;
    if (isSticky) {
      return (
        <Sticky onStickyStateChange={onStickyStateChange} topOffset={topOffset}>
          {({ style }) => (
            <div style={Object.assign({}, style, stickyStyle)} className={stickyTopClassName}>
              <WrappedComponent {...otherProps} />
            </div>
          )}
        </Sticky>
      );
    }
    return <WrappedComponent {...props} />;
  };
}
